import api from "../utils/api";
import { setAlert } from "./alert";
import {
  CLEAR_USER_ACTIVE_DAY,
  SET_INCREMENT_CIRCUIT_IN_PROGRESS,
  SET_INCREMENT_CIRCUIT_SUCCESS,
  SET_USER_ACTIVE_DAY,
} from "./types";

export function setUserActiveDay(activeDayId) {
  return async (dispatch) => {
    const token = localStorage.getItem("token");

    try {
      const res = await api.get(`user-program-days/${activeDayId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      dispatch({
        type: SET_USER_ACTIVE_DAY,
        payload: res.data.data,
      });
    } catch (error) {
      const msg = error?.response?.data?.message || "Failed to set active day";
      dispatch(setAlert(msg, "danger"));
    }
  };
}

export function clearUserActiveDay() {
  return {
    type: CLEAR_USER_ACTIVE_DAY,
  };
}

export function setActiveDayId(activeDayId) {
  return {
    type: "SET_ACTIVE_DAY_ID",
    payload: activeDayId,
  };
}

export function clearActiveDayId() {
  return {
    type: "CLEAR_ACTIVE_DAY_ID",
  };
}

export function incrementCircuitCount() {
  return async (dispatch, getState) => {
    const token = localStorage.getItem("token");
    const activeDay = getState().userActiveDayReducer.activeDay;
    
    if (!activeDay) {
      dispatch(setAlert("No active day set", "danger"));
      return;
    }

    if (activeDay.circuit > 3) {
      dispatch(setAlert("You have reached the maximum circuit count", "danger"));
      return;
    }

    dispatch({ type: SET_INCREMENT_CIRCUIT_IN_PROGRESS });

    try {
      await api.put(
        `user-program-days/${activeDay.id}`,
        { circuit: activeDay.circuit + 1 },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      dispatch({ type: SET_INCREMENT_CIRCUIT_SUCCESS });
    } catch (error) {
      const msg = error?.response?.data?.message;
      dispatch(setAlert(msg, "danger"));
    }
  };
}
